import React from "react";
import { translate } from 'react-i18next';
import { TimeUnitKeys, TimeUnits } from "../../../Enums/TimeUnits";
import { InputNumber } from "rsuite";
import LabeledSelect from '../../../components/LabeledSelect/LabeledSelect';

const NotificationInput = ({notificationValue, label, options, handleChange, hasTimeSelection, ...props}) => {
    const { t } = props;
    const {type, templateId, timeValue, timeUnit} = notificationValue;

    const timeUnits = Object.values(TimeUnits).map(x =>
        ({value: x, label: t(`workplanManager:settings.workflowNotifications.timeUnits.${TimeUnitKeys[x]}`)}))

    const handleTemplateIdChange = (value) => handleChange({type, templateId: value, timeValue, timeUnit});
    const handleTimeUnitChange = (value) => handleChange({type, templateId, timeValue, timeUnit: value});
    const handleTimeValueChange = (value) => handleChange({type, templateId, timeValue: value, timeUnit});

    const placeholder =  t('workplanManager:settings.placeholders.templates')

    return (
        <div className="notificationInput-container">
        <LabeledSelect
            id={`${type}-${templateId}`}
            label={label}
            options={options}
            value={templateId}
            handleChange={handleTemplateIdChange}
            widthSize="lg"
            className="templateIds"
            placeholder={placeholder}
            sorted
        />
        { hasTimeSelection && (
            <div className="timeSelection-container">
                    <InputNumber
                        className="number-input-1"
                        id={`${type}-${timeValue}`}
                        value={timeValue || 1}
                        min={1}
                        max={1000}
                        scrollable
                        onChange={handleTimeValueChange}
                        size="lg"
                        disabled={!templateId}
                    />

                <LabeledSelect
                        id={`${type}-${timeUnit}`}
                        options={timeUnits}
                        value={ timeUnit === null ? TimeUnits.hour : timeUnit}
                        handleChange={handleTimeUnitChange}
                        widthSize="sm"
                        disabled={!templateId}
                        searchable={false}
                    />
            </div>
        )}
        </div>
    )
}

export default translate('workplanManager')(NotificationInput);